import util from '@/libs/util.js'
import service from '@/layout/service'

function isLegacyChrome () {
  const match = window.navigator.userAgent.match(/(?:Chrome|Chromium)\/(\d+)/)
  return match ? parseInt(match[1], 10) < 50 : false
}

export default {
  namespaced: true,
  state: {
    currentHost: {
      siteName: '',
      siteShortName: '',
      siteIcon: '',
      siteLogo: ''
    },
    // 当前中心ID
    hospitalId: -1,
    indexShowType: 'grid',
    route: null,
    messageCount: 0,
    routes: []
  },
  getters: {
    routes (state) {
      return state.routes
    }
  },
  actions: {
    async loadHostConfig ({ state, dispatch }) {
      return new Promise((resolve, reject) => {
        service.hostConfig()
          .then((res) => {
            if (res && res.success) {
              resolve(res.data)
            } else {
              reject(res)
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    buildRoutes ({ state, dispatch }, plugins) {
      return new Promise((resolve, reject) => {
        const buildMicroAppTemplate = (name, plugin) => {
          const iframeAttr = plugin.iframe || isLegacyChrome() ? ' iframe' : ''
          return `<div><micro-app name='${name}' url="${plugin.url}" baseroute="/${plugin.id}"${iframeAttr}></micro-app></div>`
        }
        let admins = {
          path: '/:module/admin',
          name: 'admins',
          component: () => import('@/layout/admin'),
          children: []
        }
        let projects = {
          path: '/:module/project',
          name: 'projects',
          component: () => import('@/layout/project'),
          children: []
        }
        let users = {
          path: '/:module/my',
          name: 'users',
          component: () => import('@/layout/my'),
          children: []
        }
        let opens = {
          path: '/:module/open',
          name: 'opens',
          component: () => import('@/layout/open'),
          children: []
        }
        for (let i = 0; i < plugins.length; i++) {
          let plugin = plugins[i]
          let version = new Date().getTime()
          plugin.url = plugin.url || (location.protocol + '//' + location.host + `/${plugin.id}/index.html?v=${version}`)
          let admin = {
            path: `/${plugin.id}/admin/*`,
            name: `${plugin.id}-admin`,
            meta: { auth: true },
            component: {
              template: buildMicroAppTemplate(`${plugin.id}-admin`, plugin)
            }
          }
          admins.children.push(admin)
          let project = {
            path: `/${plugin.id}/project/:projectId(\\d+)/*`,
            name: `${plugin.id}-project`,
            meta: { auth: true },
            component: {
              template: buildMicroAppTemplate(`${plugin.id}-project`, plugin)
            }
          }
          projects.children.push(project)
          let userProj = {
            path: `/${plugin.id}/my/:projectId(\\d+)/*`,
            name: `${plugin.id}-myProj`,
            meta: { auth: true },
            component: {
              template: buildMicroAppTemplate(`${plugin.id}-myProj`, plugin)
            }
          }
          users.children.push(userProj)
          let user = {
            path: `/${plugin.id}/my/*`,
            name: `${plugin.id}-my`,
            meta: { auth: true },
            component: {
              template: buildMicroAppTemplate(`${plugin.id}-my`, plugin)
            }
          }
          users.children.push(user)
          let open = {
            path: `/${plugin.id}/open/*`,
            name: `${plugin.id}-open`,
            meta: { auth: false },
            component: {
              template: buildMicroAppTemplate(`${plugin.id}-open`, plugin)
            }
          }
          opens.children.push(open)
        }
        state.routes.push(admins)
        state.routes.push(projects)
        state.routes.push(users)
        state.routes.push(opens)
        resolve(state.routes)
      })
    },
    indexShowTypeSet ({ state, dispatch }, config) {
      return new Promise(async resolve => {
        // store 赋值
        state.indexShowType = config
        // 持久化
        await dispatch('d2admin/db/set', {
          dbName: 'system',
          path: 'common.indexShowType',
          value: state.indexShowType,
          user: true
        }, { root: true })
        // end
        resolve()
      })
    },
    load ({ state, dispatch }) {
      return new Promise(async resolve => {
        // store 赋值
        state.indexShowType = await dispatch('d2admin/db/get', {
          dbName: 'system',
          path: 'common.indexShowType',
          defaultValue: 'list',
          user: true
        }, { root: true })
        // end
        resolve()
      })
    }
  },
  mutations: {
    setCurrentHost (state, config) {
      state.currentHost = config
    },
    setHospitalId (state, hospitalId) {
      util.cookies.set('_HOSP_ID', hospitalId)
      state.hospitalId = hospitalId
    },
    setRoute (state, route) {
      state.route = route
    },
    setMessageCount (state, count) {
      state.messageCount = count
    }
  }
}
